import { useOnClickOutside } from '@amo/core/utils/hooks.js';
import _ from 'lodash';
import { useCallback, useEffect, useRef } from 'react';

const PopinOpinionsAssurances = (props) => {
    const { data, setShowPopin } = props;
    const ref = useRef();
    const dialogRef = useRef();
    useOnClickOutside(ref, () => setShowPopin(false));

    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Escape') {
            setShowPopin(false);
        }
    }, [setShowPopin]);

    // Focus trap RGAA 7.3 / 12.8
    useEffect(() => {
        const modal = dialogRef.current;
        if (!modal) return;

        const previouslyFocused = document.activeElement;
        const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

        const handleKeyDown = (e) => {
            if (e.key !== 'Tab') return;
            const focusableElements = modal.querySelectorAll(focusableSelector);
            if (focusableElements.length === 0) return;
            const first = focusableElements[0];
            const last = focusableElements[focusableElements.length - 1];

            if (e.shiftKey) {
                if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        };

        modal.addEventListener('keydown', handleKeyDown);
        const focusable = modal.querySelectorAll(focusableSelector);
        if (focusable.length > 0) focusable[0].focus();

        return () => {
            modal.removeEventListener('keydown', handleKeyDown);
            if (previouslyFocused) previouslyFocused.focus();
        };
    }, []);

    useEffect(() => {
        window.OaP = {
            CarrierId: 268,
            ProductTypeId: 2,
            UserLogin: '',
            ContactEmail: _.get(data, 'DemandeTarif[ListePersonnes][0][Email]') ?? '',
            ContactFirstName: _.get(data, 'DemandeTarif[ListePersonnes][0][Prenom]') ?? '',
            ContactLastName: _.get(data, 'DemandeTarif[ListePersonnes][0][Nom]') ?? '',
            ContactPhone: _.get(data, 'DemandeTarif[ListePersonnes][0][TelPortable]')
                ? _.replace(_.get(data, 'DemandeTarif[ListePersonnes][0][TelPortable]'), /\s/g, '')
                : '',
            IsCarrierContactAccept: false,
            CarrierExternalId: '',
        };

        const script = document.createElement('script');
        const div = document.getElementById('divOa');

        script.src = 'https://d2x33sw8v4ayed.cloudfront.net/resource/js/plugin.js';
        script.setAttribute('name', '04ebcc52a7146f9a90f318fac1f15540');
        script.setAttribute('id', 'OpinionAssurancesPlugin');

        div.appendChild(script);
    }, []);

    return (
        <div
            className={'modal-overlay position-fixed bottom-0 top-0 start-0 end-0 p-2'}
            onKeyDown={handleKeyDown}
            role="dialog"
            aria-modal="true"
            aria-label="Avis OpinionsAssurances"
            ref={dialogRef}
        >
            <div
                className={'bg-white p-4 pb-2 position-relative popin-content popin-content--full-height'}
                ref={ref}
                id="divOa"
            >
                <button type="button" className="btn-close position-absolute" style={{top: '10px', right: '10px'}} aria-label="Fermer" onClick={() => setShowPopin(false)}></button>
            </div>
        </div>
    );
};

export default PopinOpinionsAssurances;
